import requestCtxs from '@/sealFilter/requestCtxs'

//统计一级学科分类
export function subject (data) {
    return requestCtxs({
        url: '/core/ttv3/core/datahandle/ebook/statistics/top/subject/code',
        method: 'post',
        data
    })
}
//统计二级学科分类
export function Twosubject (data) {
    return requestCtxs({
        url: '/core/ttv3/core/datahandle/ebook/statistics/sec/subject/code',
        method: 'post',
        data
    })
}
//统计三级学科分类
export function Threesubject (data) {
    return requestCtxs({
        url: '/core/ttv3/core/datahandle/ebook/statistics/subject/code',
        method: 'post',
        data
    })
}

//统计三级学科分类
export function subjectBycode (data) {
    return requestCtxs({
        url: '/core/ttv3/core/datahandle/ebook/statistics/subject/code/union/kxwk',
        method: 'post',
        data
    })
}

//统计一级中图法分类
export function classify (data) {
    return requestCtxs({
        url: '/core/ttv3/core/datahandle/ebook/statistics/top/classify/code',
        method: 'post',
        data
    })
}

//统计二级中图法分类
export function Twoclassify (data) {
    return requestCtxs({
        url: '/core/ttv3/core/datahandle/ebook/statistics/sec/classify/code',
        method: 'post',
        data
    })
}

//统计三级中图法分类
export function Threeclassify (data) {
    return requestCtxs({
        url: '/core/ttv3/core/datahandle/ebook/search/classify/code',
        method: 'post',
        data
    })
}

//查询学科分类
export function subjectType (data) {
    return requestCtxs({
        url: '/core/ttv3/core/subject/new/typeinfo/query/bycondition',
        method: 'post',
        data
    })
}

//查询中图法分类
export function classifyType (data) {
    return requestCtxs({
        url: '/core/ttv3/core/classify/typeinfo/new/query/bycondition',
        method: 'post',
        data
    })
}

//院系分类
export function departmentList(data){
    return requestCtxs({
        url: '/core/ttv3/core/departmenttypeinfo/query/bypage',
        method: 'post',
        data
    })
}
//院系分类
export function bookByDepartment(data){
    return requestCtxs({
        url: '/core/ttv3/core/datahandle/ebook/search/department/code',
        method: 'post',
        data
    })
}
//出版社专题
export function pubicTheme(data){
    return requestCtxs({
        url: '/core/ttv3/core/datahandle/ebook/search/supply/auth/books',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/statistics.js